
export enum HelpBoxTypeEnum {
  SUGGESTION = 'Suggestion',
  HELP = 'Help',
}
